import parse from "html-react-parser";

const parseHtmlFromText = (text: string) => {
  return parse(text);
}

export default parseHtmlFromText;